var map = {
	"./CanvasClear": 37,
	"./CanvasClear.js": 37,
	"./CanvasMove": 38,
	"./CanvasMove.js": 38,
	"./CommandAbstract": 19,
	"./CommandAbstract.js": 19,
	"./ComponentDelete": 39,
	"./ComponentDelete.js": 39,
	"./ComponentDrag": 40,
	"./ComponentDrag.js": 40,
	"./ComponentEnter": 41,
	"./ComponentEnter.js": 41,
	"./ComponentExit": 42,
	"./ComponentExit.js": 42,
	"./ComponentNext": 43,
	"./ComponentNext.js": 43,
	"./ComponentPrev": 44,
	"./ComponentPrev.js": 44,
	"./ComponentStyleClear": 45,
	"./ComponentStyleClear.js": 45,
	"./CopyComponent": 46,
	"./CopyComponent.js": 46,
	"./DeleteComponent": 47,
	"./DeleteComponent.js": 47,
	"./ExportTemplate": 48,
	"./ExportTemplate.js": 48,
	"./Fullscreen": 49,
	"./Fullscreen.js": 49,
	"./MoveComponent": 50,
	"./MoveComponent.js": 50,
	"./OpenAssets": 51,
	"./OpenAssets.js": 51,
	"./OpenBlocks": 52,
	"./OpenBlocks.js": 52,
	"./OpenLayers": 53,
	"./OpenLayers.js": 53,
	"./OpenStyleManager": 54,
	"./OpenStyleManager.js": 54,
	"./OpenTraitManager": 55,
	"./OpenTraitManager.js": 55,
	"./PasteComponent": 56,
	"./PasteComponent.js": 56,
	"./Preview": 57,
	"./Preview.js": 57,
	"./Resize": 58,
	"./Resize.js": 58,
	"./SelectComponent": 12,
	"./SelectComponent.js": 12,
	"./SelectPosition": 24,
	"./SelectPosition.js": 24,
	"./ShowOffset": 59,
	"./ShowOffset.js": 59,
	"./SwitchVisibility": 60,
	"./SwitchVisibility.js": 60
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83;